import { AgreeTermsRequest } from 'src/models/agreeTerms';
import RootState from '../../rootState';

export class Action {
    type: string;
    agreeTerms: AgreeTermsRequest;
    termsAgreed: boolean;
}

export interface State {
    submitting: boolean;
    submitted: boolean;
    termsAgreed: boolean;
}

export const types = {
    ACTION_SERVER_DATA_AGREE_TERMS_REQUESTED: 'ACTION_SERVER_DATA_AGREE_TERMS_REQUESTED',
    ACTION_SERVER_DATA_AGREE_TERMS_FAILED: 'ACTION_SERVER_DATA_AGREE_TERMS_FAILED',

    SUBMIT_AGREE_TERMS_ASYNC: 'SUBMIT_AGREE_TERMS_ASYNC',
    SUBMIT_AGREE_TERMS_SUCCEED: 'SUBMIT_AGREE_TERMS_SUCCEED',
};

const baseAction = new Action();

export const actions = {
    actionServerDataRequested: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_AGREE_TERMS_REQUESTED
    }),

    actionServerDataFailed: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_AGREE_TERMS_FAILED
    }),

    submitAgreeTermsAsync: (agreeTerms: AgreeTermsRequest): Action => ({
        ...baseAction, type: types.SUBMIT_AGREE_TERMS_ASYNC,
        agreeTerms
    }),

    submitAgreeTermsSucceeded: (termsAgreed: boolean): Action => ({
        ...baseAction,
        type: types.SUBMIT_AGREE_TERMS_SUCCEED,
        termsAgreed
    })
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.agreeTermsData,

    submitting(rootState: RootState): boolean {
        const { submitting } = this.getState(rootState);
        return submitting;
    },

    submitted(rootState: RootState): boolean {
        const { submitted } = this.getState(rootState);
        return submitted;
    },

    termsAgreed(rootState: RootState): boolean {
        const { termsAgreed } = this.getState(rootState);
        return termsAgreed;
    },
};


// WEBPACK FOOTER //
// ./src/modules/entities/agreeTerms/index.ts